import React from 'react';
import PropTypes from 'prop-types';

import { TERMINAL_TYPE } from 'shared_modules/Terminals';

import { GatewayType } from 'pages/store/selectors/gatewayConfig';

import { getTerminalParamsByGatewayID } from '../utils';
import TerminalModal from '../TerminalModal';

const formatInitialValues = (terminalParameters, terminalGatewayID) => {
  const values = terminalParameters.reduce((parameters, currentParameter) => {
    parameters[currentParameter.id] = ''; // eslint-disable-line no-param-reassign

    return parameters;
  }, {});

  if (terminalGatewayID === GatewayType.TYRO) {
    values.type = TERMINAL_TYPE.YOMANI;
  }

  return values;
};

const AddTerminal = ({
  isOpen,
  onCancel,
  onSuccess,
  isProcessing,
  terminalParameters,
  terminalGatewayID,
  ccTerminalErrors,
}) => {
  const terminalParamsForSelectedGateway = getTerminalParamsByGatewayID(
    terminalGatewayID,
    terminalParameters
  );

  return (
    <TerminalModal
      isOpen={isOpen}
      onCancel={onCancel}
      onSuccess={onSuccess}
      isProcessing={isProcessing}
      terminalParameters={terminalParamsForSelectedGateway}
      initialValues={formatInitialValues(terminalParamsForSelectedGateway, terminalGatewayID)}
      terminalGatewayID={terminalGatewayID}
      ccTerminalErrors={ccTerminalErrors}
    />
  );
};

AddTerminal.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  isProcessing: PropTypes.bool,
  terminalParameters: PropTypes.arrayOf(PropTypes.shape(PropTypes.any.object)),
  terminalGatewayID: PropTypes.string,
  ccTerminalErrors: PropTypes.arrayOf(PropTypes.shape(PropTypes.any.object)),
};

export default AddTerminal;
